import React from "react";
import * as storeService from "../addRuleStoreService";
import { connect } from "react-redux";

function ScriptField({ remediationScript, rule, disabled }) {

    const onChange = (value) => {
        storeService.changeRule({ ...rule, remediationScript: value })
    }

    return (
        <div className="addrules-form-group-v2">
            <label className="addrules-form-label-v2">Script</label>
            <textarea
                className="addrules-form-textarea-v2 monospace"
                rows="8"
                value={remediationScript || ''}
                disabled={disabled}
                onChange={disabled ? null : event => onChange(event.target.value)}
            />
        </div>
    )

}

function mapStateToProps(state) {

    const rule = state.addRulesPage.rule;

    return {
        rule: rule || {},
        remediationScript: rule ? rule.remediationScript : ''
    }

}

export default connect(mapStateToProps)(ScriptField);
